import { render, staticRenderFns } from "./VComponent.vue?vue&type=template&id=60c73f34&scoped=true&"
import script from "./VComponent.vue?vue&type=script&lang=js&"
export * from "./VComponent.vue?vue&type=script&lang=js&"
import style0 from "./VComponent.vue?vue&type=style&index=0&id=60c73f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c73f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c73f34')) {
      api.createRecord('60c73f34', component.options)
    } else {
      api.reload('60c73f34', component.options)
    }
    module.hot.accept("./VComponent.vue?vue&type=template&id=60c73f34&scoped=true&", function () {
      api.rerender('60c73f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/inventory-items/components/items-table/VComponent.vue"
export default component.exports